"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetMedium = void 0;
/** Type of medium to be used to reset password */
var ResetMedium;
(function (ResetMedium) {
    ResetMedium["Sms"] = "SMS";
    ResetMedium["Email"] = "EMAIL";
    ResetMedium["Ivr"] = "IVR";
})(ResetMedium || (exports.ResetMedium = ResetMedium = {}));
